<template lang="pug">
article
  //-
  //- Header section
  //-
  BackgroundImage(
    src="/images/bck_fees_p.jpg"
    alt="Tarifas"
    loading="eager"
    wrapper-class="header__image__background")

    header.header__image.margin-bottom-triple
      h1.header__image__title Tarifas
      .header__image__content
        p Es un nuevo día, una nueva era en los Mercados de Capitales. Ahora tiene una ventanilla única en Portfolio Stock Exchange.

        //- p Nosotros nos encargamos de todo, le podemos ofrecer un servicio totalmente integrado y eso se traduce en más calidad, ahorro de tiempo y costes innecesarios. En Portfolio le ofrecemos:
        h5.color-gray1.margin-bottom-half Servicio integrado: Más calidad y ahorro de tiempo y costes

        ul.check
          li Mercado primario y secundario.
          li Creación de cuentas de valores y custodia.
          li Liquidación y pago de dividendos/cupones.
          li Acceso al mercado a inversores para su operativa.

        h5.color-gray1.margin-bottom-half Grandes diferencias

        ul.check
          li Sin requisitos de Free float.
          li Sin asesor registrado obligatorio.
          li Sin proveedores de liquidez obligatorios.
          li Sin agente de pagos o banco agente externo.
          li Sin broker externo.
          li Sin custodio externo.

        h5.color-gray1.margin-bottom-half Olvídese del "siempre se ha hecho así"

        ul.check
          li Olvídese de pagar fortunas a intermediarios que no le aportan valor.
          li Olvídese de las facturas sorpresa.
          li Olvídese de perder el tiempo con plazos y procesos interminables.
          li Olvídese de los dolores de cabeza.

        p Con este simulador podrá calcular los costes TOTALES y compararlo con los mercados tradicionales. Es la única forma en que usted pueda tomar una decisión bien informada.
          //- | Puede
          //- a.margin-left-quarter.margin-right-quarter(
          //-   href="/downloads/Fees-Brochure-2023_Folleto-de-Tarifas_2023-19J.pdf"
          //-   target="_blank") descargar nuestro folleto de tarifas oficial 2023 aquí
          //- | o bien utilizar el simulador de más abajo donde podrá estimar los costes totales y diferencias con los mercados tradicionales.

        h4.strong.gradient Reinventando los Mercados de Capitales tal y como deberían ser.

  //-
  //- Issuance Cost Simulator
  //-
  section.margin-bottom-double
    .section__header.section__header--left
      .section__header__cto Portfolio Stock Exchange
      h2.section__header__title Simulador de costes de emisión
      .section__header__subtitle Calcula el coste de tu emisión en Portfolio y compáralo con los mercados tradicionales.

    //- .section__body
    //-   p Una de las principales dificultades a la hora de estimar los costes de cotización en las diferentes bolsas es la complejidad de sus documentos de tarifas. Es materialmente imposible hacer el cálculo de forma autónoma.
    //-   p Tanto los documentos de tarifas de las bolsas como los de los intermediarios son confusos, llenos de partidas fijas y variables que implican una falta de transparencia absoluta y que generan una incertidumbre total en lo que al resultado final se refiere.
    //-   p Como queremos reinventar los Mercados de Capitales, aquí te proponemos este sencillo simulador para tener una idea clara e inmediata de cuál será el coste TOTAL de tu emisión a través de la vida completa de la misma.


    //-
    //- Simulator Form
    //-
    ClientOnly
      Simulator.margin-top-triple
      template(#fallback)
        .simulator-loader(style="min-height: 400px; display: flex; align-items: center; justify-content: center;")
          Loader
</template>

<script setup lang="ts">
  // Lazy load Simulator component (includes calculation logic ~60 KB)

  //
  // Data
  //

  const Simulator = defineAsyncComponent(() =>
    import('~/features/simulator').then(m => m.Simulator),
  )
  definePageMeta({
    title: 'pages.fees.title',
    description: 'pages.fees.description',
    i18n: {
      locales: ['es'],
      paths: {
        es: '/portfolio-fees',
      },
    },
  })
</script>
